import React from 'react';
import { Helmet } from 'react-helmet';
import config from 'sharedConfig';

export default function HomeHeadTags() {
  const metaTitle = `Saucey has the fastest alcohol delivery near you.  No markup + no order minimums. Get beer, wine, and liquor near you delivered.`;
  const title = config.site.defaultTitle;
  const url = config.site.url + '/';
  const description = config.site.defaultDescription;

  const organizationStructuredData = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: 'Saucey',
    url: 'https://www.saucey.com',
    logo: `${config.static.path}/images/wordmark.png`,
    sameAs: [
      'https://www.facebook.com/SauceyApp',
      'https://www.instagram.com/sauceyapp',
      'https://twitter.com/sauceyapp',
      'https://www.linkedin.com/company-beta/3734206',
      'https://www.youtube.com/sauceyapp'
    ]
  };

  const webSiteStructuredData = {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    url: 'https://www.saucey.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.saucey.com/search/{search_term_string}',
      'query-input': 'required name=search_term_string'
    }
  };

  const structuredData = [
    organizationStructuredData,
    webSiteStructuredData
  ].map(data => {
    return { key: data['@type'], json: JSON.stringify(data) };
  });

  const ogImage = `${config.static.path}/images/og-image.jpg`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      {structuredData.map(sd => (
        <script type="application/ld+json" key={sd.key}>
          {sd.json}
        </script>
      ))}
    </Helmet>
  );
}
